import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, timeout: 15000 });

export const fetchCocktails = (params = {}) => api.get("/cocktails", { params }).then(r => r.data);
export const findDrinks = (payload) => api.post("/drink-finder", payload).then(r => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then(r => r.data);
export const fetchInstagramFeed = () => api.get("/instagram/feed").then(r => r.data);
export const fetchBarCart = () => api.get("/bar-cart").then(r => r.data);
export const fetchCocktailOfTheWeek = () => api.get("/cocktail-of-the-week").then(r => r.data);
